(function (employments, $) {

    /* On search, show loading spinner */
    employments.StartLoading = function () {
        $("[data-employmentlistpartial]").hide();
        globalCore.showSpinner();
    }

    /* On search, show loading spinner */
    employments.DoneLoading = function () {
        $("[data-employmentlistpartial]").show();
        globalCore.hideSpinner();
    }

    /* On synchronize button clicked, synchronize and trigger the correct form action on click */
    employments.SynchronizeButtonClick = function (profitEnvironmentKey) {
        var button = $("[data-synchronize-modules]");
        employments.StartLoading();
        globalCore.OnSubmitBegin(button);
        $.ajax({
            method: "GET",
            url: '/Checks/EmploymentChecker/Synchronize',
            data: { 'profitEnvironmentKey': profitEnvironmentKey },
            complete: function (result) {
                employments.DoneLoading();
                globalCore.OnSubmitComplete(button);
                globalCore.onModalSuccess(result.responseJSON);
                // Also hide modal on failure
                $("#modalcontainer").modal("hide");
                globalCore.ShowAlert(result.responseJSON.success, "#sync-alert-container-employmentchecker", "De synchronisatie is voltooid.", "Er is iets fout gegaan tijdens het synchroniseren.");
                if (result.responseJSON.success) {
                    $('#searchform').submit();
                }
            }
        });
    }

    /* Initialize the Employment details datatable */
    employments.InitEmploymentDetailsGrid = function (profitEnvironmentKey, employerCode, start, end, employerName) {
        $("#showEmployeeDetailsButton").hide();
        $.ajax({
            url: "/Checks/EmploymentChecker/EmployeeDetails",
            dataType: "json",
            data: {
                profitEnvironmentKey: profitEnvironmentKey,
                employerCode: employerCode,
                start: start,
                end: end,
                employerName: employerName
            },

            success: function (employmentDetails) {
                $.fn.dataTable.moment('DD-MM-YYYY HH:mm');
                $("#employmentDetailsGrid").DataTable(datatable.defaultDataTableOptions({
                    dom: "<'row buttons-row' B><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-9 d-flex'l<'px-2'i>><'col-sm-12 col-md-3 dataTables_pager'p>>",
                    data: employmentDetails,
                    serverSide: false,
                    buttons: [
                        {
                            extend: 'excel',
                            text: 'Exporteren',
                            title: `Loonfuncties - ${employerName}`,
                            className: 'btn btn-primary'
                        }
                    ],
                    columns: [
                        {
                            title: 'Profit code',
                            data: 'code'
                        },
                        {
                            title: 'Indiensttreding',
                            data: 'dateInService'
                        },
                        {
                            title: 'Uitdiensttreding',
                            data: 'dateOutService'
                        }
                    ],
                    columnDefs: [
                        {
                            targets: [1, 2],
                            render: function (data, type, full, meta) {
                                return datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")
                            }
                        }
                    ],
                    order: [[1, 'desc']]
                }));
            }
        });
    }

}(window.employments = window.employments || {}, $));
